import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { QuillModule } from 'ngx-quill';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  MatChipsModule,
  MatChipGrid,
  MatChipRow,
  MatChipInput,
  MatChipInputEvent,
} from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { CareersService } from '../../../inputfileds/form_services/careers/careers.service';
import { environment } from '../../../../environments/environment';
import { BlobServiceClient } from '@azure/storage-blob';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { ToastService } from '../../../Services/toast/toast.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-careerpageview',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    DynamicFormQuestionComponent,
    QuillModule,
    MatChipsModule,
    MatChipGrid,
    MatChipRow,
    MatChipInput,
    MatTableModule,
    MatMenuModule,
    TranslateDirective
  ],
  templateUrl: './careerpageview.component.html',
  styleUrls: ['./careerpageview.component.scss'],
  providers: [QuestionControlService, CareersService],
})
export class CareerpageviewComponent {
  @Input() apiEndPoint!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;
  questions: Inputfiledsbase<string>[] = [];
  form!: FormGroup;
  showForm = false;
  skillList: string[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fileUrl: string | null = null;
  htmlText = '';

  cleanFileUrl: string | null = null;
  accessUrl = environment.ASSET_BLOB_URL;
  updateAccessUrl = environment.ASSET_URL;
  editUrl = environment.API_URL;
  containerName = environment.ASSET_CONTAINER;
  base_url = this.accessUrl.split('.net/')[0] + '.net/';

  CareersList: any[] = [];
  displayedColumns: string[] = [
    'position_name',
    'department_name',
    'number_of_openings',
    'experience_in_years',
    'status',
    'actions',
  ];

  currentEditId: number | null = null;
  isEditMode = false;

  quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
        ['link', 'image', 'video'],
      ],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  constructor(
    private qcs: QuestionControlService,
    private fb: FormBuilder,
    private router: Router,
    private CareersQuestionService: CareersService,
    private connectiveservices: ConnectiveservicesService,
    private apiservice: ApiservicesService,
    private route: ActivatedRoute,
    private toast: ToastService,
  ) {
    this.CareersQuestionService.getJobPostingform().subscribe(
      (q) => (this.questions = q)
    );
  }

  ngOnInit(): void {
    this.websiteId = this.route.snapshot?.queryParams['websiteId'];
    this.pageId = this.route.snapshot?.queryParams['pageId'];
    this.apiEndPoint = this.route.snapshot?.queryParams['endpoint'];

    this.initializeForm();
    this.getdata();
    console.log('Initialized with websiteId:', this.websiteId);
    console.log('Initialized with pageId:', this.pageId);
  }

  initializeForm(): void {
    this.form = this.qcs.toFormGroup(this.questions);
    this.form.addControl('company_profile', this.fb.control(''));
    this.form.addControl('is_published', this.fb.control(false));
    this.form.addControl(
      'jd_url',
      this.fb.control(this.htmlText, Validators.required)
    );
  }

  getdata(): void {
    this.apiservice.getCareersList(this.websiteId, this.pageId).subscribe({
      next: (res: any) => {
        if (res?.rows) {
          this.CareersList = res.rows;
        } else if (res?.data) {
          this.CareersList = res.data;
        } else {
          console.error('Error: No data received from API');
          this.CareersList = [];
        }
      },
      error: (err) => {
        console.error('Error fetching careers:', err);
        this.CareersList = [];
      },
    });
  }

  openJobForm(): void {
    this.resetForm();
    this.showForm = true;
  }

  navigateBack(): void {
    if (this.showForm) {
      this.resetForm();
      this.showForm = false;
    } else {
      this.router.navigate([`/websites/WebcomponentList`], {
        queryParams: { websiteId: this.websiteId, pageId: this.pageId },
      });
    }
  }

  addSkill(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && !this.skillList.includes(value)) {
      this.skillList.push(value);
    }
    event.chipInput?.clear();
  }

  removeSkill(skill: string): void {
    const index = this.skillList.indexOf(skill);
    if (index >= 0) {
      this.skillList.splice(index, 1);
    }
  }

  editSkill(skill: string, event: any): void {
    const value = event.value.trim();
    const index = this.skillList.indexOf(skill);
    if (!value) {
      this.removeSkill(skill);
    } else if (index >= 0) {
      this.skillList[index] = value;
    }
  }

  async editCareersData(id: number): Promise<void> {
    this.isEditMode = true;
    this.currentEditId = id;

    const itemToEdit = this.CareersList.find((item) => item.id === id);
    if (!itemToEdit) return;

    this.showForm = true;

    // Patch form values
    this.form.patchValue({
      position_name: itemToEdit.position_name,
      department_id: itemToEdit.department_id,
      employment_type_id: itemToEdit.employment_type_id,
      salary: itemToEdit.salary,
      number_of_openings: itemToEdit.number_of_openings,
      experience_in_years: itemToEdit.experience_in_years,
      mode_of_work: itemToEdit.mode_of_work,
      location: itemToEdit.location,
      company_profile: itemToEdit.company_profile,
      phone_number: itemToEdit.phone_number,
      email: itemToEdit.email,
      status: itemToEdit.is_published,
      jd_url: itemToEdit.jd_url,
    });

    // Handle skills
    if (itemToEdit.skills?.skills) {
      this.skillList = [...itemToEdit.skills.skills];
    }

    // Handle JD file content
    try {
      if (itemToEdit.jd_url) {
        const fileUrl = `${this.base_url}${this.containerName}/${itemToEdit.jd_url}`;
        console.log('Fetching JD content from:247', fileUrl);
        const fileContent = await this.fetchFileContent(fileUrl);
        const formattedContent = this.formatTextForQuill(fileContent);
        console.log('Formatted JD content:252', formattedContent);
        this.form.get('jd_url')?.setValue(formattedContent);
        this.htmlText = formattedContent;
      }
    } catch (error) {
      console.error('Error loading JD content:258', error);
      this.form.get('jd_url')?.setValue('');
      this.htmlText = '';
    }
  }

  private async fetchFileContent(fileUrl: string): Promise<string> {
    try {
      // ✅ Ensure full URL is constructed
      const fullUrl = fileUrl.startsWith('http')
        ? fileUrl
        : `${this.updateAccessUrl}${fileUrl}`;

      console.log('Fetching file content from (final):', fullUrl);

      const url = new URL(fullUrl);
      const containerName = url.pathname.split('/')[1]; // 'dbralc'
      const blobName = url.pathname.split('/').slice(2).join('/');

      const blobServiceClient = new BlobServiceClient(this.updateAccessUrl);
      const containerClient =
        blobServiceClient.getContainerClient(containerName);
      const blockBlobClient = containerClient.getBlockBlobClient(blobName);

      const downloadResponse = await blockBlobClient.download();

      const blobText = await downloadResponse.blobBody?.then(async (blob) => {
        return await new Response(blob).text();
      });

      return blobText || '';
    } catch (error) {
      console.error('Error fetching file content:', error);
      throw error;
    }
  }

  private formatTextForQuill(text: string): string {
    // Convert plain text to HTML for Quill
    let htmlContent = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Convert line breaks to paragraphs
    htmlContent = htmlContent
      .split('\n')
      .map((paragraph) =>
        paragraph.trim() ? `<p>${paragraph}</p>` : '<p><br></p>'
      )
      .join('');

    return htmlContent;
  }
  async onSubmit(): Promise<void> {
    if (this.form.invalid) return;

    try {
      const formData = this.form.value;
      this.fileUrl = '';
        // Create clean text file name (no timestamp)
        const cleanFileName = this.generateBlobName();
        const blobContent = this.getSanitizedJobDescription(this.htmlText);
        const blob = new Blob([blobContent], { type: 'text/plain' });
        const file = new File([blob], cleanFileName, { type: 'text/plain' });

        // Upload content file
        const urlWithSAS = await this.connectiveservices.uploadFile(file,Number(this.websiteId),'CAREERS');
        const url = urlWithSAS.split('?')[0];
        const path = new URL(url).pathname;
        this.fileUrl = path.split('/').slice(2).join('/');
        this.toast.showToast('success', 'File uploaded successfully...!');

      const submissionData = {
        ...formData,
        skills: { skills: this.skillList },
        jd_url: this.fileUrl,
        website_id: this.websiteId,
        website_page_id: this.pageId,
      };

      if (this.isEditMode && this.currentEditId) {
        await this.updateCareer(this.currentEditId, submissionData);
      } else {
        await this.createCareer(submissionData);
      }

      this.resetForm();
      this.getdata();
      this.showForm = false;
    } catch (error: any) {
      console.error('Submission error:', error.message);
    }
  }

  private getSanitizedJobDescription(htmlContent: string = ''): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Preserve line breaks
    const breaks = tempDiv.querySelectorAll('p, br, li');
    breaks.forEach((el) => {
      const br = document.createTextNode('\n');
      el.parentNode?.insertBefore(br, el.nextSibling);
    });

    return tempDiv.textContent?.trim() || '';
  }

  // private async uploadJobDescriptionToAzure(
  //   content: string,
  //   organizationData: any
  // ): Promise<string | null> {
  //   try {
  //     const blobName = this.generateBlobName();
  //     const blobPath = this.generateBlobPath(blobName, organizationData);
  //     const blobContent = content.startsWith('Job Description:')
  //       ? content
  //       : `Job Description:\n${content}`;

  //     await this.uploadBlobToAzure(blobPath, blobContent);
  //     return `${this.containerName}/${blobPath}`;
  //   } catch (error) {
  //     console.error('Azure upload failed:', error);
  //     return null;
  //   }
  // }

  private generateBlobName(): string {
    const position = this.form.get('position_name')?.value || 'Position';
    const sanitizedPosition = position
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9_]/g, '');
    const currentDate = new Date().toISOString().split('T')[0];
    return `${sanitizedPosition}_${currentDate}.txt`;
  }

  private generateBlobPath(blobName: string, organizationData: any): string {
    return `${organizationData.sub_organization_short_name}/WEBSITE_MANAGEMENT/Careers/${blobName}`;
  }

  private async uploadBlobToAzure(
    blobPath: string,
    content: string
  ): Promise<void> {
    const blob = new Blob([content], { type: 'text/plain' });
    const blobServiceClient = new BlobServiceClient(this.accessUrl);
    const containerClient = blobServiceClient.getContainerClient(
      this.containerName
    );
    const blockBlobClient = containerClient.getBlockBlobClient(blobPath);

    await blockBlobClient.uploadData(blob, {
      blobHTTPHeaders: { blobContentType: 'text/plain' },
    });
  }

  viewCareerDetails(id: string): void {
    this.router.navigate([`websites/WebcomponentList/careers`, id]);
  }

  deleteCareers(id: number): void {
    this.apiservice.deleteCareerData(id).subscribe({
      next: (res) => {
        if (res.code === 200 && res.status === true) {
          this.getdata();
        }
      },
      error: (err) => {
        console.error('Delete error:', err);
      },
    });
  }

  private async createCareer(data: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiservice.createCareers(data).subscribe({
        next: (res: any) => {
          if (res.code === 200 && res.status === true) {
            resolve();
          } else {
            reject(res.message);
          }
        },
        error: (err) => reject(err),
      });
    });
  }

  private async updateCareer(id: number, data: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiservice.updateCareerData(id, data).subscribe({
        next: (res: any) => {
          if (res.code === 200 && res.status === true) {
            resolve();
          } else {
            reject(res.message);
          }
        },
        error: (err) => reject(err),
      });
    });
  }

  updateCareerStatus(item: any): void {
    const newStatus = item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    this.apiservice
      .updateCareerData(item.id, { ...item, status: newStatus })
      .subscribe({
        next: (response: any) => {
          const index = this.CareersList.findIndex((w) => w.id === response.id);
          if (index !== -1) {
            this.CareersList[index].status = response.status;
          }
          this.getdata(); // refresh list
        },
        error: (err) => console.error('Error updating status:', err),
      });
  }

  private resetForm(): void {
    this.form.reset();
    this.skillList = [];
    this.htmlText = '';
    this.cleanFileUrl = null;
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.currentEditId = null;
    this.isEditMode = false;
  }

  onContentChanged = (event: any) => {
    if (event.source === 'user') {
      this.htmlText = event.html;
    }
  };

  onSelectionChanged = (event: any) => {
    if (event.oldRange == null) this.onFocus();
    if (event.range == null) this.onBlur();
  };

  onFocus = () => console.log('On Focus');
  onBlur = () => console.log('Blurred');

  handleApplicantView(id: any) {
    this.router.navigate([`websites/WebcomponentList/careers/applicants`], {
      queryParams: { websiteId: this.websiteId, pageId: this.pageId },
    });
  }
}
